// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import WechatOutlinedSvg from "@fishx/icons-svg/es/asn/WechatOutlined";
import FishxIcon from '../components/FishxIcon';

var WechatOutlined = function WechatOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: WechatOutlinedSvg
  }));
};

WechatOutlined.displayName = 'WechatOutlined';
export default React.forwardRef(WechatOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/WechatOutlined.js
// module id = 4389
// module chunks = 0